var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.101562,
    y: 0.5,
    width: 35.9993,
    height: 35.9993,
    rx: 8,
    fill: "url(#paint0_linear_720_15129)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.739 9.5H14.4638C11.507 9.5 9.10156 11.9055 9.10156 14.8622V22.1374C9.10156 25.0942 11.507 27.4996 14.4638 27.4996H21.739C24.6957 27.4996 27.1012 25.0942 27.1012 22.1374V14.8622C27.1012 11.9055 24.6957 9.5 21.739 9.5ZM25.2904 22.1374C25.2904 24.0988 23.7004 25.6889 21.739 25.6889H14.4638C12.5024 25.6889 10.9123 24.0988 10.9123 22.1374V14.8622C10.9123 12.9008 12.5024 11.3108 14.4638 11.3108H21.739C23.7004 11.3108 25.2904 12.9008 25.2904 14.8622V22.1374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 13.8447C15.5347 13.8447 13.4463 15.9331 13.4463 18.5C13.4463 21.067 15.5347 23.1554 18.1016 23.1554C20.6686 23.1554 22.757 21.067 22.757 18.5C22.757 15.9331 20.6686 13.8447 18.1016 13.8447ZM18.1016 21.3447C16.5306 21.3447 15.2571 20.0711 15.2571 18.5001C15.2571 16.929 16.5306 15.6555 18.1016 15.6555C19.6727 15.6555 20.9462 16.929 20.9462 18.5001C20.9462 20.0711 19.6726 21.3447 18.1016 21.3447Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7659 14.9947C23.382 14.9947 23.8814 14.4953 23.8814 13.8792C23.8814 13.2631 23.382 12.7637 22.7659 12.7637C22.1498 12.7637 21.6504 13.2631 21.6504 13.8792C21.6504 14.4953 22.1498 14.9947 22.7659 14.9947Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_15129",
    x1: 18.1012,
    y1: 0.5,
    x2: 18.1012,
    y2: 36.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7523C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#C3266B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB8B41"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.901ed6eef6ba04011451fd479a51c1a3.svg";
export { ForwardRef as ReactComponent };